import { useEffect, useRef, useState } from "react";
import { thumbnail } from "../lib/thumbs";

// One preview picture, rendered lazily: only when it scrolls into view, so a
// list of a thousand builds does not draw a thousand pictures at once.
export function Thumb(props: { id: number }) {
  const [url, setUrl] = useState<string | null>(null);
  const box = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const el = box.current;
    if (!el) return;
    let alive = true;
    const io = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      io.disconnect();
      void thumbnail(props.id).then((u) => alive && setUrl(u));
    });
    io.observe(el);
    return () => {
      alive = false;
      io.disconnect();
    };
  }, [props.id]);

  return (
    <span className="thumb" ref={box}>
      {url ? <img src={url} alt="" loading="lazy" /> : null}
    </span>
  );
}
